import { render } from "./auth-forgot-password.vue?vue&type=template&id=37d4787e"
import script from "./auth-forgot-password.vue?vue&type=script&lang=js"
export * from "./auth-forgot-password.vue?vue&type=script&lang=js"

import "./auth-forgot-password.vue?vue&type=style&index=0&id=37d4787e&lang=css"

import exportComponent from "C:\\active-project\\NeginPostClub\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__